import { Badge, Tooltip } from '@dixa/lib-shared-habla';
import { Category } from 'lib-knowledge-management-common/models/types';

import { ArrowUpIcon } from './icons/arrowUpIcon';

type RestrictionsBadgeProps = {
  restrictions: Category['restrictions'] | undefined;
};

export const RestrictionsBadge = ({
  restrictions,
}: RestrictionsBadgeProps): JSX.Element | null => {
  if (!restrictions) return null;

  const isDirect = restrictions.direct.length > 0;
  const isInherited =
    !isDirect && restrictions?.inherited && restrictions.inherited?.length > 0;

  let tooltipContent = 'Direct restriction';

  if (isInherited) {
    tooltipContent = 'Inherits restriction from parent category';
  }

  return (
    <Tooltip content={tooltipContent}>
      <Badge variant={isDirect ? 'error' : 'secondary'} size="small">
        <>
          {restrictions.direct.length > 0
            ? 'Staff only'
            : restrictions.inherited?.map((restriction, index) => (
                <div key={index}>
                  <ArrowUpIcon size={10} /> Staff only
                </div>
              ))}
        </>
      </Badge>
    </Tooltip>
  );
};
